//#region imports
import { Button, List } from "devextreme-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../../../../contexts/auth.js";
import { useLookupGroup } from "../../../../../contexts/lookup-group-context.js";
import { lookupGroups, targetGroupTypeUrlList } from "../../../../../utils/lookup-groups.ts";
import './leave-target-group.scss'
import useAxiosPrivate, { axiosHrPrivate } from "../../../../../api/useAxios.js";
//#endregion

export function TargetGroup({ formData, setFormData, setDirty, readOnly }) {
    const { activeLanguage } = useAuth()
    const { getLookupData } = useLookupGroup()
    const refListGruplar = useRef()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)

    //#region useStates
    const [targetGroupTypes, setTargetGroupTypes] = useState()
    const [selectedTargetGroupTypeId, setSelectedTargetGroupTypeId] = useState()
    const [adding, setAdding] = useState(false)
    const [targetGroupSelectionList, setTargetGroupSelectionList] = useState()

    //#endregion

    const getGroupListForSelect = async (targetGroupTypeId) => {

        const targetGroupType = targetGroupTypeUrlList.find((e) => e.id == targetGroupTypeId)

        const getClearList = (result) => {
            const tempList = formData.leaveInfoTargetGroups.map((item) => (item.targetGroupValueId))
            const list = result.filter(item => !tempList.includes(item.targetGroupValueId))
            return list
        }

        if (!targetGroupType)
            return null

        try {
            var response = await axiosPrivate.get(`${targetGroupType.url}${targetGroupType.parentId}`)
            if (response) {
                if (response.data?.data) {
                    let result = response?.data?.data.sort((a, b) => a.order - b.order).
                        map(item => (
                            {
                                leaveInfoId: formData.id,
                                targetGroupTypeId: targetGroupTypeId,
                                targetGroupValueId: item.id,
                                targetGroupValueName: item.text ?? item.name,
                            }))

                    return getClearList(result)
                }
            }
            return null
        } catch (error) {
            console.log("getLookupDataFromApi error : ", error)
        }
    }

    const onClickAddGroup = (e) => {
        setAdding(!adding)
    }

    const onHandleTargetGroupTaypesSelectionChange = (e) => {
        setSelectedTargetGroupTypeId(e[0].id)
    }

    const onHandleDeleted = (e) => {
        setDirty(true)
    }

    useEffect(() => {
        getLookupData(lookupGroups.targetGroupType).then(response => setTargetGroupTypes(response))

    }, [activeLanguage])

    useEffect(() => {
        getGroupListForSelect(selectedTargetGroupTypeId).then((response) => { setTargetGroupSelectionList(response) })
    }, [selectedTargetGroupTypeId])

    return (

        <React.Fragment>
            <div className="adding-button">
                <Button
                    icon={adding ? "chevronup" : "add"}
                    onClick={onClickAddGroup}
                ></Button>
            </div>
            {adding && <div className="target-group-layout">
                <div className="target-group-types"  >
                    <div className="dx-card caption">Kategoriler</div>
                    <div className="dx-card">
                        <List
                            dataSource={targetGroupTypes}
                            selectionMode="single"
                            keyExpr="id"
                            displayExpr="text"
                            height={200}
                            onSelectedItemsChange={onHandleTargetGroupTaypesSelectionChange}
                            disabled={readOnly}
                        />
                    </div>
                </div>

                <div className="target-group-selection ">
                    <div className="dx-card caption">Gruplar</div>
                    <div className="dx-card">
                        <List
                            itemRender={ListItemRender(
                                refListGruplar,
                                formData,
                                setFormData,
                                setDirty)}
                            ref={refListGruplar}
                            keyExpr="targetGroupValueId"
                            displayExpr="targetGroupValueName"
                            searchExpr="targetGroupValueName"
                            searchEnabled={true}
                            height={200}
                            dataSource={targetGroupSelectionList}
                            disabled={readOnly}
                        >
                        </List>
                    </div>
                </div>
            </div>}


            <div className="target-group-list">
                <div className="dx-card caption-list">Hedef Kitle</div>
                <div className="dx-card">
                    <List
                        searchEnabled={true}
                        dataSource={formData.leaveInfoTargetGroups}
                        keyExpr="targetGroupValueId"
                        displayExpr="targetGroupValueName"
                        allowItemDeleting={true}
                        itemDeleteMode="static"
                        height={250}
                        onItemDeleted={onHandleDeleted}
                        disabled={readOnly}
                    >
                    </List>
                </div>
            </div>
        </React.Fragment>
    )
}

function ListItemRender(list,
    formData,
    setFormData,
    setDirty) {

    return function Template(item) {
        const onHandleClick = (e) => {
            const targetGrup = {
                leaveInfoId: item.leaveInfoId,
                targetGroupTypeId: item.targetGroupTypeId,
                targetGroupValueId: item.targetGroupValueId,
                targetGroupValueName: item.targetGroupValueName,
            }

            list.current.instance.deleteItem(item)
            var tmpList = [...formData.leaveInfoTargetGroups, targetGrup]

            setFormData((prev) => {
                return {
                    ...prev,
                    leaveInfoTargetGroups: tmpList
                }
            })
            setDirty(true)
        }
        return (
            <div className="item-container">
                <div className="item-text">{item.targetGroupValueName}</div>
                <Button icon="plus"
                    style={{ height: "20px" }}
                    onClick={onHandleClick}
                />

            </div>
        )
    }
}
